module.exports = __webpack_public_path__ + "static/yalco-book-1-f5a717b6d924e4ffbe9b422a1eaa06b4.png";